module.exports = __webpack_public_path__ + "img/connection.7edcca6.png";